import { render } from "./ModuleSelector.vue?vue&type=template&id=0dfa140a"
import script from "./ModuleSelector.vue?vue&type=script&lang=js"
export * from "./ModuleSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__